<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

const props = defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
  showReport: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['edit', 'delete', 'report']);

const handleEdit = campaign => emit('edit', campaign);
const handleDelete = campaign => emit('delete', campaign);
const handleReport = campaign => {
  if (!props.showReport) return;
  emit('report', campaign);
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :campaign-type="campaign.campaign_type"
      :report-summary="showReport ? campaign.report_summary : null"
      :is-live-chat-type="isLiveChatType"
      :is-clickable="showReport"
      @edit="handleEdit(campaign)"
      @delete="handleDelete(campaign)"
      @click="handleReport(campaign)"
    />
  </div>
</template>
